@if (status() === 'error') {
  @let hint = errorHint();
  <cmi-notification
    class="block mb-3"
    mode="error"
    [message]="errorKey() | translate: maxFilings"
    [description]="hint ? (hint | translate: maxFilings) : (errorDetail() ?? undefined)"
    [actionLabel]="hint ? undefined : ('mailUpload.retry' | translate)"
    (actionClick)="onUpload()" />
}

<cmi-button
  [label]="'mailUpload.button' | translate"
  [loadingLabel]="'mailUpload.uploading' | translate"
  [loading]="uploading()"
  [disabled]="!ready()"
  [fullWidth]="true"
  (clicked)="onUpload()" />
